import { aiCreditPrices } from "@shared/lib/planHelpers";
import { prettyDate } from "@shared/lib/time";

export function formatResetDate(periodEndsAt?: number | null): string {
  return periodEndsAt ? prettyDate(periodEndsAt) : "next period";
}

export function formatCents(cents: number): string {
  const dollars = Math.abs(cents) / 100;
  const formatted = `$${dollars.toFixed(2)}`;
  return cents < 0 ? `-${formatted}` : formatted;
}

export interface AiPrice {
  lookupKey: string;
  name: string;
  kind: "subscription" | "one_off";
  credits: number;
  priceId: string;
  priceDollars: number;
  currency: string;
  interval: string | null;
}

export function splitTiers(pricesData: any): {
  subscriptionTiers: AiPrice[];
  topUpTiers: AiPrice[];
} {
  const all: AiPrice[] = pricesData ? aiCreditPrices(pricesData.data || []) : [];
  return {
    subscriptionTiers: all.filter((p) => p.kind === "subscription"),
    topUpTiers: all.filter((p) => p.kind === "one_off"),
  };
}

export function deriveTierButtonText(
  isSubscribed: boolean,
  currentPrice: number | null,
  tierPrice: number,
): string {
  if (!isSubscribed) return "Subscribe";
  if (currentPrice != null && tierPrice > currentPrice) return "Upgrade";
  if (currentPrice != null && tierPrice < currentPrice) return "Downgrade";
  return "Change plan";
}

// Mirrors the analog's getPlanButtonType (planLookups.js:578-584): the button's
// visual style is derived from the button TEXT, not from a plan attribute.
// Primary for the upgrade/start actions ("Upgrade" + the AI-credit start action
// "Subscribe", the analog of "Start plan"/"Start free trial"), secondary for
// other changes ("Change plan").
export function deriveTierButtonType(buttonText: string): "primary" | "secondary" {
  if (buttonText === "Upgrade" || buttonText === "Subscribe") {
    return "primary";
  }
  return "secondary";
}

